import { Mark } from '@tiptap/core'

export const ChunkMark = Mark.create({
  name: 'chunk',

  inclusive: false,

  addAttributes() {
    return {
      chunkId: {
        default: null,
        parseHTML: (element: HTMLElement) => element.getAttribute('data-chunk-id'),
        renderHTML: (attrs: Record<string, any>) => (attrs['chunkId'] ? { 'data-chunk-id': attrs['chunkId'] } : {}),
      },
    }
  },

  parseHTML() {
    return [
      {
        tag: 'span[data-chunk-id]',
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return ['span', HTMLAttributes, 0]
  },
})
